import {DocumentNode, gql} from "@apollo/client";

export const SIGN_UP_MUTATION: DocumentNode = gql(`    
    mutation SignUp($signUpDto: SignUpRequest!) {
      signUp(signUpDto: $signUpDto) {
        ...AuthInfo
      }
    }
`);
